module.exports = __webpack_public_path__ + "img/cri.1c28eb78.png";